export default function IblSkillsStartController() {

}